import { useEffect } from "react";

/**
 * Lazy-loads analytics + pixels only when env IDs are set.
 * Add IDs in /app/frontend/.env:
 *   REACT_APP_GA4_ID, REACT_APP_META_PIXEL_ID, REACT_APP_LINKEDIN_ID,
 *   REACT_APP_TIKTOK_ID, REACT_APP_HOTJAR_ID
 */
export default function Analytics() {
  useEffect(() => {
    const ga = process.env.REACT_APP_GA4_ID;
    const meta = process.env.REACT_APP_META_PIXEL_ID;
    const linkedin = process.env.REACT_APP_LINKEDIN_ID;
    const tiktok = process.env.REACT_APP_TIKTOK_ID;
    const hotjar = process.env.REACT_APP_HOTJAR_ID;

    // Google Analytics 4
    if (ga && !window.__ga_loaded) {
      window.__ga_loaded = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", ga, { anonymize_ip: true });
    }

    // Meta Pixel
    if (meta && !window.__fb_loaded) {
      window.__fb_loaded = true;
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      window.fbq("init", meta);
      window.fbq("track", "PageView");
    }

    // LinkedIn Insight Tag
    if (linkedin && !window.__li_loaded) {
      window.__li_loaded = true;
      window._linkedin_partner_id = linkedin;
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(linkedin);
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      document.head.appendChild(s);
    }

    // TikTok Pixel
    if (tiktok && !window.__tt_loaded) {
      window.__tt_loaded = true;
      /* eslint-disable */
      !function (w, d, t) { w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"]; ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; }; for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; }; ttq.load = function (e, n) { var i = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = i; ttq._t = ttq._t || {}; ttq._t[e] = +new Date; ttq._o = ttq._o || {}; ttq._o[e] = n || {}; var o = document.createElement("script"); o.type = "text/javascript"; o.async = !0; o.src = i + "?sdkid=" + e + "&lib=" + t; var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a); }; ttq.load(tiktok); ttq.page(); }(window, document, 'ttq');
      /* eslint-enable */
    }

    // Hotjar
    if (hotjar && !window.__hj_loaded) {
      window.__hj_loaded = true;
      /* eslint-disable */
      (function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:hotjar,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-',".js?sv=");
      /* eslint-enable */
    }
  }, []);

  return null;
}

// Helper to track conversion events from anywhere
export function trackLeadEvent(loanType = "unknown", value = 0) {
  if (typeof window === "undefined") return;
  if (window.gtag) window.gtag("event", "generate_lead", { loan_type: loanType, value, currency: "AUD" });
  if (window.fbq) window.fbq("track", "Lead", { content_category: loanType, value, currency: "AUD" });
  if (window.ttq) window.ttq.track("SubmitForm", { content_type: loanType });
}
